import React from 'react';
import { useInterface } from '../../context/InterfaceProvider';
import SciFiIcon from './SciFiIcon';

export function SimpleImageHeading({ children }) {
  const { version } = useInterface();
  if (version !== 'simple') return <>{children}</>;
  const kind = children.startsWith('Grader') ? 'grading' : children.startsWith('Scan') ? 'centering' : children.startsWith('Misc') ? 'misc' : 'images';
  return <span className="simple-image-heading"><span>{children}</span><SciFiIcon kind={kind} /></span>;
}

export function SimpleImageZoom() {
  const { version } = useInterface();
  if (version !== 'simple') return null;
  return (
    <button type="button" className="simple-image-zoom" aria-label="Zoom image" onClick={(event) => {
      // Use the existing image trigger so its lightbox and magnification stay unchanged.
      event.currentTarget.closest('.card-images')?.querySelector('.card-image-display')?.click();
    }}>
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="6" /><path d="m15 15 6 6M10 7v6m-3-3h6" /></svg>
    </button>
  );
}
